/**
 * DTaledDesigns UI | Lightbox
 *
 * @author DTaledDesigns
 */

// DTaledDesigns UI Lightbox
class DTaledDesignsUiLightbox {
	constructor(element) {
		this.element = element;
		this.lightbox = document.querySelector('.site-dtaleddesigns-ui-lightbox');
		this.lightboxContent = this.lightbox.querySelector('.site-dtaleddesigns-ui-lightbox__content');
		this.lightboxContentInner = this.lightbox.querySelector('.site-dtaleddesigns-ui-lightbox__content-inner');
		this.closeButton = this.lightbox.querySelector('.site-dtaleddesigns-ui-lightbox__close');
		this.backdrop = this.lightbox.querySelector('.site-dtaleddesigns-ui-lightbox__backdrop');

		this.element.addEventListener('click', this.openLightbox.bind(this));
		this.closeButton.addEventListener('click', this.closeLightbox.bind(this));
		this.backdrop.addEventListener('click', this.closeLightbox.bind(this));
		this.lightbox.addEventListener('keydown', this.handleKeydown.bind(this));

		// Add ARIA attributes
		this.element.setAttribute('aria-haspopup', 'dialog');
		this.lightbox.setAttribute('role', 'dialog');
		this.lightbox.setAttribute('aria-modal', 'true');
		this.lightbox.setAttribute('aria-hidden', 'true');
		this.lightboxContent.setAttribute('role', 'document');
		this.closeButton.setAttribute('aria-label', 'Close Lightbox');
	}

	helperIsImageType(src) {
		// Check if the source URL ends with common image extensions
		return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(src);
	}

	helperValueNullOrUndefined(checkedElement) {
		return checkedElement && typeof checkedElement !== 'undefined' && typeof checkedElement.value !== 'undefined' && checkedElement.value !== '';
	}

	openLightbox() {
		this.lightboxContentInner.innerHTML = '';

		if (this.helperValueNullOrUndefined(this.element.nextElementSibling)) {
			this.lightboxContentInner.innerHTML = this.element.nextElementSibling.value;

			this.lightbox.classList.add('site-dtaleddesigns-ui-lightbox--active');

			this.lightbox.removeAttribute('aria-hidden');
			this.lightbox.focus();

			document.querySelectorAll('[dtaleddesigns-event]').forEach(function(_sel) {
				_sel.addEventListener('click', function(e) {
					if (e.href) {
						e.preventDefault();
					}

					window._dtaledDesigns.events.push(_sel.dataset.c, _sel.dataset.a, _sel.dataset.l || '', _sel.dataset.v || '');

					if (e.href) {
						document.location.href = e.href;
					}
				});
			});
			return;
		}

		if (this.element && typeof this.element.getAttribute('data-src') !== 'undefined' && this.element.getAttribute('data-src') !== '') {
			const src = this.element.getAttribute('data-src');

			if (this.helperIsImageType(src)) {
				// Create an image element
				const image = document.createElement('img');
				image.src = src;
				image.className = 'site-dtaleddesigns-ui-lightbox__image';

				// Clear previous content
				this.lightboxContentInner.innerHTML = '';
				this.lightboxContentInner.appendChild(image);
			} else {
				// Create an iframe element
				const iframe = document.createElement('iframe');
				const iframeWrapper = document.createElement('div');
				iframe.src = src;
				iframeWrapper.className = 'site-dtaleddesigns-ui-lightbox__iframe-wrapper';
				iframe.className = 'site-dtaleddesigns-ui-lightbox__iframe-wrapper-frame';
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('allowfullscreen', 'true');

				// Clear previous content
				this.lightboxContentInner.innerHTML = '';
				iframeWrapper.appendChild(iframe);
				this.lightboxContentInner.appendChild(iframeWrapper);
			}

			// Show the lightbox
			this.lightbox.classList.add('site-dtaleddesigns-ui-lightbox--active');

			// Update ARIA attributes
			this.lightbox.removeAttribute('aria-hidden');
			this.lightbox.focus();
		}
	}

	closeLightbox() {
		// Hide the lightbox
		this.lightbox.classList.remove('site-dtaleddesigns-ui-lightbox--active');

		// Update ARIA attributes
		setTimeout(() => {
			this.lightboxContentInner.innerHTML = '';
			this.lightbox.setAttribute('aria-hidden', 'true');
			this.element.focus();
		}, 300);
	}

	handleKeydown(event) {
		if (event.key === 'Escape') {
			this.closeLightbox();
		}
	}
}

HTMLDivElement.prototype.dtaledDesignsUiLightbox = function() {
	return new DTaledDesignsUiLightbox(this);
};

